import { g as u, a as y, b as d } from "./domains-5b6d38aa.js";
const o = {
  asurion: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  starhub: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  true: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  techcare: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  asurion_techcare: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  celcom: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  umobile: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  lazada: { code: "TH", country: "Thailand", countryCodeNumber: "65" },
  maxis: { code: "MY", country: "Malaysia", countryCodeNumber: "60" },
  demo1: { code: "SG", country: "Singapore", countryCodeNumber: "65" },
  twopenmarket_synnex: { code: "TW", country: "Taiwan", countryCodeNumber: "886" },
  cht_home: { code: "TW", country: "Taiwan", countryCodeNumber: "886" }
}, r = {
  asurion: "en-US",
  starhub: "en-US",
  true: "en-US",
  techcare: "th-TH",
  asurion_techcare: "th-TH",
  celcom: "ms-MY",
  umobile: "ms-MY",
  lazada: "th-TH",
  maxis: "en-US",
  demo1: "en-US",
  twopenmarket_synnex: "zh-Hant-TW",
  cht_home: "zh-Hant-TW"
}, n = (e) => o[e] || { code: "", country: "", countryCodeNumber: "" }, t = (e) => r[e] || "en-US";
export {
  u as getCarrierByDomain,
  n as getCountryByCarrier,
  t as getDefaultLanguageByCarrier,
  y as getTypeByDomain,
  d as getUrlByTypeAndEnv
};
